import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setTempPropMngData } from "@/store/globalSlice"
import { getCurrentPlayer, getMapById } from "@/utils/gameHelpers"
import { PrimaryButton } from "@/Components/PrimaryButton"
import Color from "color"
import classNames from "classnames"
import Money from "@/Components/Money"
import {
  canPutHousesOnPropertyGroup,
  checkForSimilarGroupPropertiesOfPlayer,
} from "@/utils/propmngHelpers"
import { HouseItem } from "./HouseItem"

interface IPropertyActionsCardProps {
  cell: ICell
  showHouses: boolean
}
export const PropertyActionsCard: React.FC<IPropertyActionsCardProps> = ({
  cell,
}) => {
  const dispatch = useAppDispatch()
  const myGame = useAppSelector((state) => state.global.myGame)
  const tempPropMngData = useAppSelector(
    (state) => state.global.tempPropMngData
  )
  const propMngState = { myGame, tempPropMngData }

  const myMapId = myGame!.settings.mapId
  const myMap = getMapById(myMapId)
  const group = myMap?.groups.find(
    (group) => group.id === cell.propertyDetails?.groupId
  )
  const player = getCurrentPlayer(myGame as IGameDetails)
  const property = cell.propertyDetails
  const isPropertyMortgaged =
    tempPropMngData.mortgagedProperties.includes(cell.order)

  const showHouses = canPutHousesOnPropertyGroup(
    propMngState,
    player!.order,
    property!.groupId || ""
  )
  const houseData = tempPropMngData.houseData.find(
    (houseData) => houseData.propertyOrder === cell.order
  )
  const showMortgageButton = checkForSimilarGroupPropertiesOfPlayer(
    propMngState,
    player!.order,
    cell.order,
    (item) => item.houses === 0
  )
  const handleClickOnMortgage = () => {
    dispatch(
      setTempPropMngData({
        mortgagedProperties: [
          ...tempPropMngData.mortgagedProperties,
          cell.order,
        ],
      })
    )
  }
  const handleClickOnUnMortgage = () => {
    dispatch(
      setTempPropMngData({
        mortgagedProperties: tempPropMngData.mortgagedProperties.filter(
          (prop) => prop !== cell.order
        ),
      })
    )
  }
  if (!houseData) return null

  return (
    <div
      data-testid="propmng.action-card"
      className={classNames(
        "grid grid-cols-[1fr_2fr_1fr] px-4 py-2 text-white font-poppins items-center",
        { "grayscale-[100%]": isPropertyMortgaged }
      )}
      style={{
        backgroundColor: Color(group?.color).fade(0.5).toString(),
        borderColor: Color(group?.color).toString(),
        borderWidth: 1,
        borderStyle: "solid",
        // boxShadow: "inset 5px 5px 50px black",
      }}
    >
      <div className="text-white text-xl uppercase">{property?.name}</div>

      {!isPropertyMortgaged && showHouses ? (
        <div
          className="flex gap-4 items-center justify-center"
          data-testid={`propmng.houses-wrapper-${cell.order}`}
        >
          {Array(3)
            .fill(0)
            .map((_, i) => (
              <HouseItem index={i} cell={cell}></HouseItem>
            ))}
        </div>
      ) : (
        <div></div>
      )}

      {isPropertyMortgaged ? (
        <PrimaryButton
          className="flex flex-row w-full"
          data-testid={`propmng.un-mortgage-btn-${cell.order}`}
          onClick={handleClickOnUnMortgage}
        >
          <div className="flex items-center gap-4 text-lg">
            Un-Mortgage
            <div className="flex items-center text-base">
              ({" "}
              <Money
                iconClass="h-3/5"
                className="gap-1"
                money={(cell.propertyDetails!.mortgagedPrice * 1.1).toFixed(0)}
              ></Money>
              )
            </div>
          </div>
        </PrimaryButton>
      ) : showMortgageButton ? null : //   data-testid={`propmng.mortgage-btn-${cell.order}`} //   className="flex flex-row w-full" // <PrimaryButton
      //   onClick={handleClickOnMortgage}
      // >
      //   <div className="flex items-center gap-4 text-lg">
      //     Mortgage
      //     <div className="flex items-center text-base">
      //       ({" "}
      //       <Money
      //         iconClass="h-3/5"
      //         className="gap-1"
      //         money={cell.propertyDetails!.mortgagedPrice.toFixed(0)}
      //       ></Money>
      //       )
      //     </div>
      //   </div>
      // </PrimaryButton>
      null}
    </div>
  )
}
